import React from "react";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC", // Explicitly setting the timezone to UTC
  };
  const timeOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "UTC", // Explicitly setting the timezone to UTC
  };
  const formattedDate = new Intl.DateTimeFormat("en-US", dateOptions).format(
    date
  );
  const formattedTime = new Intl.DateTimeFormat("en-US", timeOptions).format(
    date
  );

  return [formattedDate, formattedTime]; // Adjust options as needed
};

const DateFormatter = ({ date }) => {
  const data = formatDate(date);
  return (
    <p>
      {data[0]}/{data[1]}
    </p>
  );
};

export default DateFormatter;
